<template>
    <div
        class="bax-form-group"
        v-bind:class="error != '' ? 'bax-input-error' : ''"
    >
        <label v-if="label === ''">
            <slot name="label"></slot>
        </label>

        <label v-if="label !== ''">
            {{ label }}
        </label>

        <select
            class="bax-input-control"
            :value="value"
            v-on:input="updateValue($event.target.value)"
        >
            <option value="" v-if="defaultOption !== ''">
                {{ defaultOption }}
            </option>
            <option
                v-for="(opt, index) in options"
                :key="index"
                :value="getOptionValue(opt)"
            >
                {{ getOptionText(opt) }}
            </option>
        </select>
        <p>{{ error }}</p>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'VueSelect',
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
        },
        optionText: {
            type: String,
            default: '',
        },
        defaultOption: {
            type: String,
            default: '',
        },
        optionValue: {
            type: String,
            default: '',
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
        getOptionText(opt) {
            return _.get(opt, this.optionText);
        },
        getOptionValue(opt) {
            return _.get(opt, this.optionValue);
        },
    },
};
</script>

<style scoped>
</style>
